import React from "react";

import Icon from "@/components/ui/Icon/Icon";
import { IDocument } from "@/types";

import AnchorLink from "../ui/AnchorLink/AnchorLink";

const DocumentLink: React.FC<IDocument> = (props) => {
  const { icon, name, doc, cta } = props;
  return (
    <div className="flex bg-gray-7 rounded-xl p-m justify-between mb-xl items-center">
      <div className="flex items-center flex-1">
        <Icon className="stroke-black mr-xs" name={icon.icon} size="24" title={name} />
        <span className="font-primary uppercase text-s md:text-s">{name}</span>
      </div>
      {cta &&
        cta.map((linkList, index) => (
          <>
            <AnchorLink
              key={index}
              href={linkList?.link?.url || doc.url}
              className="btn btn-primary-white btn-small font-medium border-0 text-center shadow-elevation whitespace-nowrap"
            >
              {linkList.label}
            </AnchorLink>
          </>
        ))}
    </div>
  );
};

export default DocumentLink;
